import React from "react";
import "./HeroNosotros.css";

const HeroNosotros = () => {
  return (
    <section className="hero-nosotros">
      <div className="hero-overlay-Nosotros">
        <h1 className="hero-title-Nosotros">Apasionados por el whisky</h1>
      </div>
    </section>
  );
};

export default HeroNosotros;
